export const CONTACT_TYPE_LABELS: Record<string, string> = {
  directory: 'Directory',
  external: 'External',
};